import login from './login/reducers'

export default {
  login,
}
